module.exports = __webpack_public_path__ + "img/animated.26e83d85.gif";